var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhitePermision(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143",
    transform: "translate(0 0.288)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 20,
    height: 20,
    transform: "translate(0 -0.288)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(0 -0.668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(1.419 1.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M1763.749,2453.68l1.771-1.771a1.671,1.671,0,1,0-.523-.523l-1.771,1.771Z",
    transform: "translate(-1751.025 -2448.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M1702.348,2514.034l-1.771,1.771a1.67,1.67,0,1,0,.523.523l1.771-1.771Z",
    transform: "translate(-1697.879 -2502.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M1701.357,2450.5a1.669,1.669,0,1,0-.78,1.41l1.771,1.771.523-.523-1.771-1.771A1.654,1.654,0,0,0,1701.357,2450.5Z",
    transform: "translate(-1697.879 -2448.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M1765.52,2515.8l-1.771-1.771-.523.523,1.771,1.771a1.668,1.668,0,1,0,.523-.523Z",
    transform: "translate(-1751.025 -2502.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M1736.586,2448.211a.37.37,0,0,0-.6,0l-1.32,1.826a.37.37,0,0,0,.3.587h.95v1.312h.74v-1.312h.95a.37.37,0,0,0,.3-.587Z",
    transform: "translate(-1727.689 -2448.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M1737.606,2521.37h-.95v-1.312h-.74v1.312h-.95a.37.37,0,0,0-.3.587l1.32,1.826a.37.37,0,0,0,.6,0l1.32-1.826a.37.37,0,0,0-.3-.587Z",
    transform: "translate(-1727.689 -2507.315)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M1699.229,2488.714a.37.37,0,0,0,.587-.3v-.951h1.312v-.74h-1.312v-.95a.37.37,0,0,0-.587-.3l-1.826,1.32a.37.37,0,0,0,0,.6Z",
    transform: "translate(-1697.25 -2478.783)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M1772.975,2486.794l-1.826-1.32a.37.37,0,0,0-.587.3v.95h-1.312v.74h1.312v.951a.37.37,0,0,0,.2.33.374.374,0,0,0,.385-.03l1.826-1.321a.37.37,0,0,0,0-.6Z",
    transform: "translate(-1755.935 -2478.783)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M1721.708,2467.517a5,5,0,1,0,5,5A5,5,0,0,0,1721.708,2467.517Zm-.535,2.073a1.136,1.136,0,0,1,.415-.1.443.443,0,0,0,.063-.012h.047l.165.022a1.163,1.163,0,0,1,1.022.972,1.15,1.15,0,0,1-.254.979,1.066,1.066,0,0,1-.643.352,1.32,1.32,0,0,1-.964-.2,1.055,1.055,0,0,1-.5-.757A1.176,1.176,0,0,1,1721.172,2469.591Zm2.661,5.592h-4.251v-.845a2.126,2.126,0,1,1,4.251,0Z",
    transform: "translate(-1711.693 -2462.838)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePermision);
export default __webpack_public_path__ + "static/media/white_permision.0205ef3a9185aa1589ab98feadc751f9.svg";
export { ForwardRef as ReactComponent };